import ApplicationController from './application_controller.js'

// Shows/hides target section(s) based on whether the toggle <select>/input is set to "true".
// The sections stay in the DOM (just hidden) so their fields still submit and nothing is lost.
export default class extends ApplicationController {
  static targets = ['toggle', 'section']

  connect() {
    this.update()
  }

  update() {
    const enabled = this.toggleTarget.value === 'true'
    this.sectionTargets.forEach((section) =>
      section.classList.toggle('hidden', !enabled)
    )
  }
}
